module.exports = __webpack_public_path__ + "static/media/pw.069ec370.svg";